export default "__VITE_ASSET__DJFM$f6c__"